// extracted by mini-css-extract-plugin
export var boxItems = "_7f-1";
export var button = "_7f-5";
export var filterGroupBox = "_7f-0";
export var icon = "_7f-2";
export var iconSecondary = "_7f-4";
export var iconWrapper = "_7f-3";